import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectBranchesListItems } from "../../../../../../redux/branches/selector";
import { branches } from "../../../../../../redux/branches/action";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";


const ManagementBranches = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const [pageData, setPageData] = useState(1)
    const branchesItems = useSelector(selectBranchesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'BranchInfo.Name', headerName: 'Name' },
        //   { field: 'BranchInfo.BranchTypeId', headerName: 'BranchType', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraries.BranchType } },
         // { field: 'BranchInfo.OrganizationUnitId', headerName: 'Suppliers Name', valueFormatter: getOrganizationUnit },
          { field: 'BranchInfo.IsPrimaryBranch', headerName: 'PrimaryBranch', cellRenderer: 'yesNoRenderer' }
      
        ]);
      }
      const fetchBranches=()=>{

        dispatch(branches.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/branches/list`,entity:'branches',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchBranches()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add Branches',
      callback: () => handleAdd(),
    }
  ];
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.BranchInfo?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(branches.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/branches/delete`,
      entity: 'branches',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(branches.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/branches/list`,entity:'branches',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {branchesItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={branchesItems?.result?.items} setPageData={setPageData}
    paginationData={branchesItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Branches" />
  }
  </> 
     
	);
};

export default ManagementBranches;


